import { render, staticRenderFns } from "./LockConfirmationArea.vue?vue&type=template&id=bc035d48"
import script from "./LockConfirmationArea.vue.js?vue&type=script&lang=js&external"
export * from "./LockConfirmationArea.vue.js?vue&type=script&lang=js&external"
import style0 from "./LockConfirmationArea.vue?vue&type=style&index=0&id=bc035d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
